<template>
  <a-popover placement="bottomRight">
    <template #content>
      <a-row class="list-column-filter" :gutter="[14, 14]">
        <template v-for="item in fieldsOptions">
          <a-col :span="8">
            <a-checkbox v-if="disabledOptions[item.dataIndex]" :checked="true" disabled>{{ item.title }}</a-checkbox>
            <a-checkbox v-else :checked="fieldsCheckedMap[item.dataIndex]" @update:checked="v => changeItemSetting(item, v)">{{ item.title }}</a-checkbox>
          </a-col>
        </template>
      </a-row>
    </template>
    <template #title>
      <span>表头显示设置</span>
    </template>
    <dol-icon class="dol-list-column-setting-icon" type="SettingOutlined"/>
  </a-popover>
</template>

<script>
export default {
  name: 'dol-list-column-setting',
  props: {
    fields: { type: Object, default: () => [] },
    showListFields: { type: Object, default: () => ({}) },
  },
  computed: {
    fieldsCheckedMap(){
      const map = {};
      this.fields.forEach(item => {
        if(typeof this.showListFields[item.dataIndex] === 'boolean'){
          map[item.dataIndex] = this.showListFields[item.dataIndex];
        }else{
          map[item.dataIndex] = item.queryFilter;
        }
      });
      return map;
    },
    disabledOptions(){
      const map = {};
      this.fields.forEach(item => {
        if(typeof item.listFilter === 'undefined'){
          map[item.dataIndex] = true;
        }
      });
      return map;
    },
    fieldsOptions(){
      return this.fields.filter(item => {
        if(item.listHidden) return false;
        return item.dataIndex !== 'operation';
      });
    },
  },
  data () {
    return {};
  },
  methods: {
    changeItemSetting(item, v){
      this.$emit('update:show-list-fields', {
        ...this.showListFields,
        [item.dataIndex]: v
      });
    }
  }
}
</script>

<style lang="scss">
@use '../../../assets/scss/constant' as constant;
.dol-list-column-setting-icon{
  font-size: 14px;
  cursor: pointer;
  &:hover{
    color: constant.$primaryColor;
  }
}
.list-column-filter{
  width: 400px;

  .list-column-filter-item{
    width: 100%;
    display: flex;
    align-items: center;

    .item-title{
      flex: 1;
    }
  }
}
</style>
